import React from 'react'
import { Bar } from 'react-chartjs-2'

const options = {
  scales: {
    x: {
      stacked: true
    },
    y: {
      stacked: true,
      beginAtZero: true,
      min: 0,
      max: 100
    }
  },
  plugins: {
    title: {
      display: false,
      position: 'top'
    },
    legend: {
      display: true,
      position: 'bottom'
    },

    tooltip: {
      callbacks: {
        label: (context) => {
          return `${context.dataset.label}: ${context.formattedValue}%`
        }
      }
    }
  },
  responsive: true
}

export const MonthlyAttachmentChart = ({ values = {} }) => {
  const approvedDataset = Object.values(values).map(
    ({ status_percentages: statusPercentages = {} }) =>
      statusPercentages.approved
  )
  const pendingUploadDataset = Object.values(values).map(
    ({ status_percentages: statusPercentages = {} }) =>
      statusPercentages.pending_upload
  )
  const rejectedUploadDataset = Object.values(values).map(
    ({ status_percentages: statusPercentages = {} }) =>
      statusPercentages.rejected + statusPercentages.expired
  )
  const pendingDataset = Object.values(values).map(
    ({ status_percentages: statusPercentages = {} }) =>
      statusPercentages.pending
  )

  const labels = Object.keys(values).filter(label => label !== "S/I"); // Quitar el elemento S/I

  const data = {
    labels,
    datasets: [
      {
        label: 'Documentos aprobados',
        data: approvedDataset,
        backgroundColor: '#2E90FA',
        borderWidth: 1,
        borderRadius: 6,
        datalabels: { display: false }
      },
      {
        label: 'Documentos rechazados',
        data: rejectedUploadDataset,
        backgroundColor: '#F3736A',
        borderWidth: 1,
        borderRadius: 6,
        datalabels: { display: false }
      },
      {
        label: 'Documentos por cargar',
        data: pendingUploadDataset,
        backgroundColor: '#F2F4F7',
        borderWidth: 1,
        borderRadius: 6,
        datalabels: { display: false }
      },
      {
        label: 'Documentos por revisar',
        data: pendingDataset,
        backgroundColor: '#F5D324',
        borderWidth: 1,
        borderRadius: 6,
        datalabels: { display: false }
      }
    ]
  }
  return <Bar className='w-full' options={options} data={data} />
}
